<template>
    <div
        class="flex flex-col items-center justify-center text-center px-4 py-8 animate-fade-in-up"
        role="status"
        aria-live="polite"
    >
        <template v-if="!error">
            <div
                class="w-24 h-24 rounded-full bg-theme-card shadow-lg flex items-center justify-center mb-5"
            >
                <tag-icon
                    class="w-14 h-14 text-stack-primary origin-tag-eyelet animate-tag-swing"
                />
            </div>
            <h2 class="text-xl font-bold text-theme-base mb-1">
                Iniciando sesión con Google
            </h2>
            <p class="text-theme-muted text-sm max-w-xs">
                Te estamos llevando a Google para confirmar tu cuenta. Esto toma
                solo unos segundos.
            </p>
        </template>

        <template v-else>
            <div
                class="w-24 h-24 rounded-full bg-theme-danger bg-opacity-10 flex items-center justify-center mb-5"
            >
                <svg
                    class="w-12 h-12 text-theme-danger"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                </svg>
            </div>
            <h2 class="text-xl font-bold text-theme-base mb-1">
                No pudimos conectar con Google
            </h2>
            <p class="text-theme-muted text-sm max-w-xs mb-5">
                {{ error }}
            </p>
            <div class="w-full sm:w-10/12 flex flex-col gap-2">
                <app-button size="large" block border @click="$emit('retry')">
                    Intentar de nuevo
                </app-button>
                <button
                    type="button"
                    class="text-sm text-theme-muted hover:text-theme-base underline"
                    @click="$emit('cancel')"
                >
                    Ingresar de otra forma
                </button>
            </div>
        </template>
    </div>
</template>

<script>
import TagIcon from "@/components/icons/TagIcon.vue";

export default {
    name: "FederatedSignInProgress",
    components: { TagIcon },
    props: {
        error: { type: String, default: "" }
    }
};
</script>
